import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'
import {
  Box, Button, ListItem, Text, StatusBadge,
} from '@domain-group/suit-theme'

import { buildItemTitle, buildOptionsString } from '@functions/orderItem'
import { statusColors } from '@functions/status'

import useOrderItem from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'

import ItemManagement from './ItemManagement'

interface OrderItemProps {
  last?: boolean,
  orderItem: OrderItemModel,
}

const OrderItem = (props: OrderItemProps) => {
  const { last = false, orderItem } = props

  const orderItemPayload = useOrderItem(orderItem)
  const {
    callbacks: { manageOrderItem },
    orderItem: {
      options: orderItemOptions,
    },
    publication: { title: publicationTitle },
    publicationEdition: { publication_date },
    status,
  } = orderItemPayload

  const updatedDateString = digObject(orderItem, 'dates.updated.date_time')
  const updatedDate = DateTime.fromFormat(updatedDateString, 'dd/MM/yyyy HH:mm')

  return (
    <Box borderBottom={last ? 'none' : '1px dashed'} borderColor="lineColor" flexDirection="column">
      <ListItem boxProps={{ padding: 'large' }} disableHover>
        <Box flexDirection="row" alignItems="center">
          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">
              {publicationTitle && `${publicationTitle} - `}
              {buildItemTitle({ orderableItem: orderItem, excludeOptionsString: true })}
            </Text>
            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
              {/*
               // @ts-expect-error TS2345 */}
              {publication_date ? `Published ${publication_date}` : buildOptionsString(orderItemOptions)}
            </Text>
          </Box>

          <Box alignItems="center" display={['none', 'flex']} justifyContent="center" marginLeft="auto" width="auto">
            <Box alignItems="flex-end" flexDirection="column">
              <StatusBadge
                // @ts-expect-error TS7053
                color={statusColors[status.key || 'pending']}
                ghost
                text={status.title || 'Approved'}
              />

              <Text color="lightGrey" fontSize="xsmall" marginTop="medium" style={{ whiteSpace: 'nowrap' }}>
                {updatedDate.toFormat("dd/MM/yyyy 'at' HH:mm")}
              </Text>
            </Box>

            <Button
              buttonStyle="secondaryUtility"
              // @ts-expect-error TS2322
              marginLeft="large"
              onClick={() => manageOrderItem()}
              size="medium"
              width="auto"
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </Button>
          </Box>
        </Box>
      </ListItem>

      <Box>
        <ItemManagement orderItemPayload={orderItemPayload} />
      </Box>
    </Box>
  )
}

export default OrderItem
